import * as React from 'react';
import { GetTrackProps, SliderItem } from 'react-compound-slider';

export interface TrackProps {
    source: SliderItem,
    target: SliderItem,
    getTrackProps: GetTrackProps
}

// function Track({source, target, getTrackProps}) { // your own track component
//     return (
//         <div
//             style={{
//                 position: 'absolute',
//                 height: 10,
//                 zIndex: 1,
//                 marginTop: 35,
//                 backgroundColor: '#546C91',
//                 borderRadius: 5,
//                 cursor: 'pointer',
//                 left: `${source.percent}%`,
//                 width: `${target.percent - source.percent}%`,
//             }}
//             {...getTrackProps()} // this will set up events if you want it to be clickeable (optional)
//         />
//     );
// }

export class Track extends React.Component<TrackProps> {
    public render() {
        const props = this.props;
        const target = props.target;
        const source = props.source;
        return <div
            className="pf-range-track"
            style={{
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...props.getTrackProps()} // this will set up events if you want it to be clickeable (optional)
        />;
    }
}
